var map = {
	"./DeleteIcon": "b04a",
	"./DeleteIcon.vue": "b04a",
	"./EditIcon": "7941",
	"./EditIcon.vue": "7941",
	"./MinusSign": "21b4",
	"./MinusSign.vue": "21b4",
	"./PlusSign": "448c",
	"./PlusSign.vue": "448c",
	"./ReplyIcon": "7694",
	"./ReplyIcon.vue": "7694",
	"./design/active-states.jpg": "ceb5",
	"./design/desktop-design.jpg": "b78b",
	"./design/desktop-modal.jpg": "37c3",
	"./design/desktop-preview.jpg": "a449",
	"./design/mobile-design.jpg": "34b1",
	"./design/mobile-modal.jpg": "93fb",
	"./design/ss my work.jpg": "ae0c",
	"./images/avatars/image-amyrobson.png": "f32e",
	"./images/avatars/image-amyrobson.webp": "9d9d",
	"./images/avatars/image-juliusomo.png": "f166",
	"./images/avatars/image-juliusomo.webp": "5add",
	"./images/avatars/image-maxblagun.png": "b1a7",
	"./images/avatars/image-maxblagun.webp": "1737",
	"./images/avatars/image-ramsesmiron.png": "0bd9",
	"./images/avatars/image-ramsesmiron.webp": "b9d5",
	"./images/icon-delete.svg": "11ca",
	"./images/icon-edit.svg": "eaaf",
	"./images/icon-minus.svg": "b398",
	"./images/icon-plus.svg": "77ea",
	"./images/icon-reply.svg": "7b82",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";